import { AppError, AppErrorCode } from '@repo/error';
import type { DocumentSide } from '@repo/shared/types';

const apiUrl = process.env.BUN_PUBLIC_API_URL ?? '';

export type UploadDocumentResult = {
  document: {
    _id: string;
    fileId: string;
    documentType: string;
    side: string;
    extractionStatus: string;
    isAcceptedByUser: boolean;
    extractedData: unknown;
  };
};

export async function uploadReportDocument(
  organizationId: string,
  reportId: string,
  file: File,
  documentType: string,
  side?: DocumentSide,
): Promise<UploadDocumentResult> {
  const form = new FormData();
  form.append('file', file);
  form.append('documentType', documentType);
  if (side) form.append('side', side);

  const res = await fetch(`${apiUrl}/api/reports/${reportId}/documents`, {
    method: 'POST',
    headers: {
      'x-organization-id': organizationId,
    },
    credentials: 'include',
    body: form,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new AppError(AppErrorCode.UNKNOWN_ERROR, {
      message: text,
      statusCode: res.status,
    });
  }

  return res.json() as Promise<UploadDocumentResult>;
}

export async function deleteReportDocument(
  organizationId: string,
  reportId: string,
  documentId: string,
): Promise<{ success: boolean }> {
  const res = await fetch(`${apiUrl}/api/reports/${reportId}/documents/${documentId}`, {
    method: 'DELETE',
    headers: {
      'x-organization-id': organizationId,
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  if (!res.ok) {
    const text = await res.text();
    throw new AppError(AppErrorCode.UNKNOWN_ERROR, {
      message: text,
      statusCode: res.status,
    });
  }

  return res.json() as Promise<{ success: boolean }>;
}
